<form [formGroup]="form">
  <mat-form-field class="date-picker" floatLabel="always">
    <mat-label>
      @if (mainLabelLiteral) {
        {{ mainLabel }}
      } @else {
        {{ mainLabel | i18nextCap }}
      }
    </mat-label>
    <input
      matInput
      formControlName="date"
      [required]="required"
      [matDatepicker]="datePicker"
      [matDatepickerFilter]="dateFilter"
      #dateInput
    />
    <mat-datepicker-toggle matSuffix [for]="datePicker">
    </mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
    <mat-error>
      {{
        ngControl.errors?.message
          ? ('error:' + ngControl.errors?.message | i18nextCap)
          : ('validation:youMustSelectADate' | i18nextCap)
      }}
    </mat-error>
  </mat-form-field>
  <mat-form-field class="time-picker" floatLabel="always">
    <mat-label>{{ timeLabel | i18nextCap }}</mat-label>
    <fo-time-input
      formControlName="time"
      [min]="minTimeMinutes"
      [max]="maxTimeMinutes"
    ></fo-time-input>
  </mat-form-field>
</form>
